import * as React from 'react'
import moment from 'moment'
import type { Moment } from 'moment'

import { ActivityModel } from 'app/models'
import { FaIcon } from '@/lib/fa'
import { formatDuration } from '@/modules/drivers/hooks/useDateHelper'
import { SUMMARY_TYPES, calcDurations } from './MonthlyChartHeader'

type MonthlyActivitiesFooterProps = {
  startTime: Moment
  days: number
  activities: ReadonlyArray<ActivityModel>
  translate: (key: string) => any
  left: number
  width: number
  height: number
}

const MonthlyActivitiesFooter: React.FC<MonthlyActivitiesFooterProps> = ({
  startTime,
  days,
  activities,
  translate,
  left,
  width,
  height,
}) => {
  const start = moment(startTime)
  const end = start.clone().add(days, 'days')
  const durations = calcDurations(start, end, activities)

  const label = translate('monthlyActivity.activities')?.toString?.() ||
    'Aktywności'

  return (
    <div
      className="tw-flex tw-items-center tw-justify-between tw-gap-4 tw-border-t tw-border-base-300 tw-bg-white tw-px-4 tw-shadow-[0_-1px_4px_rgba(0,0,0,0.06)]"
      style={{
        position: 'fixed',
        bottom: 0,
        left,
        width,
        height,
        zIndex: 30,
      }}
    >
      <span className="tw-text-sm tw-font-semibold tw-uppercase tw-text-content-base">
        {label}
      </span>

      <div className="tw-flex tw-items-center tw-gap-4">
        {SUMMARY_TYPES.map(({ type, icon }) => (
          <div
            key={type}
            className="tw-flex tw-items-center tw-gap-1.5 tw-text-content-base"
          >
            <FaIcon icon={icon} className="tw-h-3.5 tw-text-content-base/70" />
            <span className="tw-text-xs tw-font-medium tw-tabular-nums">
              {formatDuration(moment.duration(durations[type]))}
            </span>
          </div>
        ))}
      </div>
    </div>
  )
}

export default MonthlyActivitiesFooter
